import apiClient from '@/api/client';
import type { ClientConfig } from '@/types/config';

export async function fetchClientConfig(): Promise<ClientConfig> {
  const response = await apiClient.get<ClientConfig>('/api/v1/config');
  return response.data;
}
